<template>
  <div>
    <!-- input search -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Recherche</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Recherche"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
      <b-form-group>
        <b-button
          :to="{ name: 'create-credit' }"
          variant="gradient-primary"
          class="ml-1 d-inline-block"
        >
          <feather-icon icon="PlusIcon" />
          <span class="ml-1">Ajouter un credit</span>
        </b-button>
      </b-form-group>
    </div>
    <div
      v-if="isLoading === true"
      class="text-center mb-2"
    >
      <b-spinner
        variant="primary"
        label="Text Centered"
      />
    </div>
    <!-- table -->
    <vue-good-table
      style-class="vgt-table striped bordered condensed"
      :columns="columns"
      :rows="customers"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Name -->
        <div
          v-if="props.column.field === 'name'"
          class="text-nowrap"
        >
          <b-avatar
            :src="props.row.avatar"
            class="mx-1"
          />
          <span class="text-nowrap">{{ props.row.name }}</span>
        </div>
        <span v-else-if="props.column.field === 'action'">

        <router-link
          class="text-success"
          :to="{ name: 'show-credit',
                  params: { id: props.row.id} }"
        > <feather-icon
          :id="`invoice-row-${props.row.id}-show-icon`"
          icon="EyeIcon"
          class="cursor-pointer mr-1"
          size="16"
        /></router-link>
            <b-tooltip
              title="Historique credit"
              class="cursor-pointer"
              :target="`invoice-row-${props.row.id}-show-icon`"
            />
        <router-link
          class="text-success"
          :to="{ name: 'create-payment',
                  params: { id: props.row.id} }"
        > <feather-icon
          :id="`invoice-row-${props.row.id}-showdel-icon`"
          icon="EditIcon"
          class="cursor-pointer mr-1"
          size="16"
        /></router-link>
        <b-tooltip
              title="Payer credit"
              class="cursor-pointer"
              :target="`invoice-row-${props.row.id}-showdel-icon`"
            />
        </span>
        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              Affichage 1 à
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap "> {{ props.total }} résultats trouvés </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import {
  BAvatar, BPagination, BFormGroup, BFormInput, BFormSelect, BButton,
  BSpinner, BTooltip,

} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
import axiosIns from '@/libs/axios'

export default {
  components: {
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BSpinner,
    BTooltip,
  },
  data() {
    return {
      isLoading: false,
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: 'Client',
          field: 'company_name',
          filterOptions: {
            enabled: true,
            placeholder: 'Client',
          },
        },
        {
          label: 'téléphone',
          field: 'phone',
          filterOptions: {
            enabled: true,
            placeholder: 'téléphone',
          },
        },
        {
          label: 'credit',
          field: 'credit',
          filterOptions: {
            enabled: true,
            placeholder: 'credit',
          },
        },
        
        {
          label: 'Action',
          field: 'action',
        },
      ],
      searchTerm: '',
      customers: [],
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  created() {
    this.getCustomers()
  },
  methods: {
    async getCustomers() {
      this.isLoading = true

      const { data } = await axiosIns.get('/credits/')
      this.customers = data
      this.isLoading = false
    },
    async deleteCustomer(id) {
      const result = await this.$swal({
        title: 'Êtes-vous sûr?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui, je veux supprimer ce client',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
      this.isLoading = true
      if (result.value) {
        await axiosIns.delete(`/customers/delete/${id}`)
        this.isLoading = false
        this.getCustomers()
      } else if (result.dismiss === 'cancel') {
        this.isLoading = false
        this.$swal({
          title: 'Fermer',
          text: 'Client non supprimé',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success',
          },
        })
      }
    },
    // toast
    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },
  },
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
